import { DefaultState } from '@src/redux/types'

import {
  STAFF,
  STAFF_ALL,
  STAFF_ALL_FILTERED,
  STAFF_DELETE,
  STAFF_DEPARTMENT_POSITION,
  STAFF_FULL_INFO_UPDATE,
  STAFF_LIST,
  STAFF_PERSONAL_INFO,
  STAFF_USERNAME,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [STAFF]: DefaultState<`${typeof API.STAFF_INFO}{id}`, 'get'>
  [STAFF_ALL]: DefaultState<`${typeof API.STAFF_ALL}`, 'get'>
  [STAFF_ALL_FILTERED]: DefaultState<`${typeof API.STAFF_ALL_FILTERED}`, 'get'>
  [STAFF_PERSONAL_INFO]: DefaultState<`${typeof API.STAFF_PERSONAL_INFO}`, 'put'>
  [STAFF_FULL_INFO_UPDATE]: DefaultState<`${typeof API.STAFF_FULL_INFO}`, 'put'>
  [STAFF_DELETE]: DefaultState<`${typeof API.STAFF}{id}`, 'delete'>
  [STAFF_LIST]: DefaultState<`${typeof API.STAFF}`, 'get'>
  [STAFF_DEPARTMENT_POSITION]: DefaultState<`${typeof API.STAFF_DEPARTMENT_POSITION}`, 'get'>
  [STAFF_USERNAME]: DefaultState<`${typeof API.STAFF_USERNAME}{username}`, 'get'>
} = () => ({
  [STAFF]: defaultState(),
  [STAFF_ALL]: defaultState(),
  [STAFF_ALL_FILTERED]: defaultState(),
  [STAFF_PERSONAL_INFO]: defaultState(),
  [STAFF_FULL_INFO_UPDATE]: defaultState(),
  [STAFF_DELETE]: defaultState(),
  [STAFF_LIST]: defaultState(),
  [STAFF_DEPARTMENT_POSITION]: defaultState(),
  [STAFF_USERNAME]: defaultState(),
})
